import { useEffect, useRef, useState } from "react";
import './AssistencesSearchBar.scss';
import { ToggleButton, ToggleButtonGroup } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { ROLES } from "aw-consts";
import { ISelectOptions } from "aw-combobox";
import { AWSelect } from "aw-select";

interface AssistencesSearchBarProps {
    options1: ISelectOptions[];
    options2: ISelectOptions[];
    options3: ISelectOptions[];
    selectedOption1: ISelectOptions | undefined | null;
    selectedOption2: ISelectOptions | undefined | null;
    selectedOption3: ISelectOptions | undefined | null;

    defaultIni: string;
    defaultFin: string;

    role: number;
    showEyeButton?: boolean;
    classNameSuccess?: string;
    rounded?: string;
    containerColor?: string;
    dark?: boolean;
    downloadButton?: boolean;
    disableMachineSelect: boolean;
    onClickNew: () => void;
    onClickReload: () => void;
    onChangeSelected1: (e: any) => void;
    onChangeSelected2: (e: any) => void;
    onChangeSelected3: (e: any) => void;
    onChangeDates: (e: any) => void;
    onSwitchChange: (e: any) => void;
}

const AssistencesSearchBar = ({
    options1,
    options2 = [],
    options3 = [],
    selectedOption1,
    selectedOption2,
    selectedOption3,
    defaultIni,
    defaultFin,
    role,
    showEyeButton = false,
    dark = false,
    downloadButton = true,
    disableMachineSelect = false,
    classNameSuccess = 'btn btn-success buttonRadius',
    rounded = 'rounded-3',
    containerColor = 'var(--background-secondary)',
    onClickNew,
    onChangeDates,
    onChangeSelected1,
    onChangeSelected2,
    onChangeSelected3,
    onClickReload,
    onSwitchChange
}: AssistencesSearchBarProps) => {

    const [selectedValue, setSelectedValue] = useState(selectedOption1);
    const [selectedValue2, setSelectedValue2] = useState(selectedOption2);
    const [selectedValue3, setSelectedValue3] = useState(selectedOption3);
    const [comboOptions, setComboOptions] = useState<ISelectOptions[]>(options1);
    const [comboOptions2, setComboOptions2] = useState<ISelectOptions[]>(options2);
    const [comboOptions3, setComboOptions3] = useState<ISelectOptions[]>(options3);
    const searchButton = useRef<HTMLButtonElement>(null);
    const [switchButton, setSwitchButton] = useState("calendar");
    const { t } = useTranslation();

    useEffect(() => {
        setSelectedValue(selectedOption1);
        setComboOptions(options1);
    }, [options1, selectedOption1]);

    useEffect(() => {
        setSelectedValue2(selectedOption2);
        setComboOptions2(options2);
    }, [options2, selectedOption2]);

    useEffect(() => {
        setSelectedValue3(selectedOption3);
        setComboOptions3(options3);
    }, [options3, selectedOption3]);

    const selectChange = (o: any) => {
        if (o) {
            const selectedValue = options1.filter((c: any) => c.value == o.value);
            setSelectedValue(selectedValue[0]);
        }
        onChangeSelected1(o);
    };

    const selectChange2 = (o: any) => {
        if (o) {
            const selectedValue = options2.filter((c: any) => c.value == o.value);
            setSelectedValue2(selectedValue[0]);
        }
        onChangeSelected2(o);
    };

    const selectChange3 = (o: any) => {
        if (o) {
            const selectedValue = options3.filter((c: any) => c.value == o.value);
            setSelectedValue3(selectedValue[0]);
        }
        onChangeSelected3(o);
    };

    const onClickSearch = () => {
        if (searchButton.current) searchButton.current.disabled = true;
        onClickReload();

        setTimeout(() => {
            if (searchButton.current) searchButton.current.disabled = false;
        }, 5000);
    };

    const handleSwitchChange = (opt: string) => {
        setSwitchButton(opt)
        onSwitchChange(opt)
    }

    return (
        <div className={`p-2 ${rounded} assistences-search-bar-container `} style={{ backgroundColor: containerColor }}>
            <div className="row p-1">
                <div className="col-12 col-lg-4 text-start">
                    <div className="d-flex align-items-center gap-3">
                        <button type='button' onClick={onClickNew} className={`${classNameSuccess}`} style={{ width: '40px' }}>
                            <i className="bi bi-plus-circle"></i>
                        </button>

                        <ToggleButtonGroup type="radio" className="d-flex" name="options" value={switchButton} onChange={handleSwitchChange}>
                            <ToggleButton id="r-measures" value={"calendar"} className='btn-Custom btn-IDGreen'>
                                {t('Calendar')}
                            </ToggleButton>
                            <ToggleButton id="r-alarms" value={"list"} className='btn-Custom btn-IDGreen'>
                                {t('List')}
                            </ToggleButton>
                        </ToggleButtonGroup>
                    </div>
                </div>
                <div className="col-6 col-lg-2  text-start">
                    <AWSelect dark={dark}
                        clearable
                        placeholder={t('Machine')}
                        options={comboOptions}
                        value={selectedValue}
                        onChange={selectChange}
                        menuPortalTarget={document.body}
                    />
                </div>
                <div className="col-6 col-lg-2  text-start">
                    <AWSelect dark={dark}
                        clearable
                        placeholder={t('Type')}
                        options={comboOptions2}
                        value={selectedValue2}
                        onChange={selectChange2}
                        menuPortalTarget={document.body}
                    />
                </div>
                <div className="col-6 col-lg-2">
                    <AWSelect dark={dark}
                        clearable
                        placeholder={t('User')}
                        options={comboOptions3}
                        value={selectedValue3}
                        onChange={selectChange3}
                        menuPortalTarget={document.body}
                    />
                </div>

                {role !== ROLES.Provider && (
                    <>
                        {/* <div className="col-6 col-lg-2  text-start date-container">
                            <Form.Control
                                name="iniDate"
                                className={dark ? 'date-picker dark' : 'date-picker'}
                                type="date"
                                defaultValue={defaultIni}
                                onChange={onChangeDates}
                            />
                        </div> */}
                        {/* <div className="col-6 col-lg-2 text-end date-container">
                            <Form.Control
                                name="finDate"
                                className={dark ? 'date-picker dark' : 'date-picker'}
                                type="date"
                                defaultValue={defaultFin}
                                onChange={onChangeDates}
                            />
                        </div> */}


                    </>
                )}

                {/* <div className="col-12 col-lg-1 ms-auto d-flex justify-content-end">
                    <button ref={searchButton} onClick={onClickSearch} className={`large-button ${classNameSuccess} ${showEyeButton || downloadButton ? 'me-2' : ''}`}>
                        <i className="bi bi-search"></i>
                    </button>
                </div> */}
            </div>
        </div>
    );
};

export default AssistencesSearchBar;